import ReactMarkdown, { type Options } from 'react-markdown'
import rehypeExternalLinks from 'rehype-external-links'

interface Props {
  text: string | undefined
  options?: Options
}

function Markdown({ text, options }: Props) {
  return (
    <div className="markdown">
      <ReactMarkdown
        {...options}
        rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
        components={{
          strong: ({ node, ...props }) => (
            <strong style={{ fontWeight: 600 }} {...props} />
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  )
}

export { Markdown }
